
define('text!modules/htmlad/templates/htmlad_templates_template.html',[],function () { return '<div class="htmlad-templates-list js-htmlad-templates-list"></div>\r\n';});

